import eventBus from '../eventBus'
import { IEBTopicData } from '../eventBus/eventBus.types'

const requestConfirm = async (
  data: IEBTopicData['confirm-service.request'] = {}
): Promise<{ response: 'confirm' | 'cancel' }> => {
  eventBus.pub('confirm-service.request', data) // open the modal

  return eventBus.waitForEvent('confirm-service.response')
}

const confirmService = { requestConfirm }
export default confirmService
